import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import {
  Pelayanan,
  Tindakan,
  Diagnosis,
  Procedure,
  KondisiDasar
} from "@/types/billing";
import SvcBilling from "@/services/Billing";
import { storePasien } from "@/store/modules/pasien";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { userModule } from "./user";

@Module({ dynamic: true, namespaced: true, store, name: "billing" })
class Billing extends VuexModule {
  pelayanan: Pelayanan[] = null;
  hasilTindakan: Tindakan[] = null;
  listTindakan: Tindakan[] = null;
  diagnosis: Diagnosis = null;
  diagnosisUnit: Diagnosis = null;
  procedure: Procedure = null;
  loading = false;
  kondisiDasar: KondisiDasar = null;
  askep = {};

  get pasien(): any {
    return storePasien.identitasPasien;
  }

  get register(): any {
    return RegisterKunjungan.register;
  }

  get stateUser() {
    return userModule.user;
  }

  @Mutation
  SET_PELAYANAN(pelayanan: Pelayanan[]) {
    this.pelayanan = pelayanan;
  }

  @Mutation
  SET_HASIL_TINDAKAN(hasilTindakan: Tindakan[]) {
    this.hasilTindakan = hasilTindakan;
  }

  @Mutation
  SET_LIST_TINDAKAN(listTindakan: Tindakan[]) {
    this.listTindakan = listTindakan;
  }

  @Mutation
  SET_LIST_DIAGNOSIS(diagnosis: Diagnosis) {
    console.log("set list diagnosis", diagnosis);
    this.diagnosis = diagnosis;
  }
  @Mutation
  SET_LIST_DIAGNOSIS_UNIT(diagnosisUnit: Diagnosis) {
    this.diagnosisUnit = diagnosisUnit;
  }

  @Mutation
  SET_LIST_PROCEDUR(procedure: Procedure) {
    this.procedure = procedure;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  SET_KONDISI_DASAR(kondisiDasar: KondisiDasar) {
    this.kondisiDasar = kondisiDasar;
  }

  @Mutation
  SET_ASKEP(askep: {}) {
    this.askep = askep;
  }

  @Mutation
  RESET_ALL() {
    this.pelayanan = null;
    this.hasilTindakan = null;
    this.listTindakan = null;
    this.diagnosis = null;
    this.diagnosisUnit = null;
    this.procedure = null;
    this.kondisiDasar = null;
    this.askep = null;
  }

  @Action({ rawError: true })
  async getPelayananByUnit(unitID): Promise<void> {
    this.SET_PELAYANAN(null);
    // this.SET_LOADING(true);
    const pelayananArray = await SvcBilling.getPelayananbyUnit(unitID).finally(
      () => {
        // this.SET_LOADING(false);
      }
    );
    this.SET_PELAYANAN(pelayananArray.data ? pelayananArray.data : null);
  }

  @Action({ rawError: true })
  async getTindakanbyReg(reg): Promise<void> {
    this.SET_HASIL_TINDAKAN(null);
    this.SET_LOADING(true);
    const tindakanArray = await SvcBilling.getTindakanbyReg(reg).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_HASIL_TINDAKAN(tindakanArray.data ? tindakanArray.data : null);
  }

  @Action({ rawError: true })
  async getTindakanbyRequest(val): Promise<void> {
    this.SET_LIST_TINDAKAN(null);
    // this.SET_LOADING(true);
    const listTindakan = await SvcBilling.getTindakanbyRequest(
      val.reg,
      val.tgl,
      val.jam,
      val.unit
    ).finally(() => {
      // this.SET_LOADING(false);
    });
    this.SET_LIST_TINDAKAN(listTindakan.data ? listTindakan.data : null);
  }

  @Action({ rawError: true })
  async getDiagnosis(reg): Promise<void> {
    const eps = this.stateUser?.unit_id >= "50" ? "ri" : "rj";

    this.SET_LIST_DIAGNOSIS(null);
    // this.SET_LOADING(true);
    const listDiagnosis = await SvcBilling.getDiagnosisbyReg(reg, eps).finally(
      () => {
        // this.SET_LOADING(false);
      }
    );
    this.SET_LIST_DIAGNOSIS(listDiagnosis.data ? listDiagnosis.data : null);
  }

  @Action({ rawError: true })
  async getDiagnosisByUnit(param): Promise<void> {
    const eps = param.unit_id >= "50" ? "ri" : "rj";

    this.SET_LIST_DIAGNOSIS_UNIT(null);
    // this.SET_LOADING(true);
    const listDiagnosis = await SvcBilling.getDiagnosisbyReg(
      param.reg,
      eps
    ).finally(() => {
      // this.SET_LOADING(false);
    });
    this.SET_LIST_DIAGNOSIS_UNIT(
      listDiagnosis.data ? listDiagnosis.data : null
    );
  }

  @Action({ rawError: true })
  async getProcedure(reg): Promise<void> {
    const eps = this.stateUser?.unit_id >= "50" ? "ri" : "rj";

    this.SET_LIST_PROCEDUR(null);
    // this.SET_LOADING(true);
    const listProcedur = await SvcBilling.getProcedurebyReg(reg, eps).finally(
      () => {
        // this.SET_LOADING(false);
      }
    );
    this.SET_LIST_PROCEDUR(listProcedur.data ? listProcedur.data : null);
  }

  @Action({ rawError: true })
  async clearBilling(): Promise<void> {
    this.SET_HASIL_TINDAKAN(null);
    this.SET_LIST_TINDAKAN(null);
    this.SET_LIST_DIAGNOSIS(null);
    this.SET_LIST_PROCEDUR(null);
  }

  @Action({ rawError: true })
  async getKondisiDasar(unit): Promise<void> {
    this.SET_KONDISI_DASAR(null);
    // this.SET_LOADING(true);
    const kondisiDasar = await SvcBilling.getKondisiDasar(unit).finally(() => {
      // this.SET_LOADING(false);
    });
    this.SET_KONDISI_DASAR(kondisiDasar.data ? kondisiDasar.data : null);
  }

  @Action({ rawError: true })
  async getAskep(param): Promise<void> {
    this.SET_LOADING(true);
    this.SET_ASKEP(null);
    const askep = await SvcBilling.getAskep(param).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_ASKEP(askep.data ? askep.data : null);
  }

  @Action reset() {
    this.RESET_ALL();
  }
}

export default getModule(Billing);
